module.exports = __webpack_public_path__ + "img/openkey.58fa51e1.png";